import { IField } from "../interfaces/inputs/IField";

export const ProductGroupFields: IField[] = [
  { name: "name", type: "text", label: "Name", size: {lg: 12}, position: 1 },
  { name: "code", type: "text", label: "Code", size: {lg: 12}, position: 2 },
].sort((a: IField, b: IField) => a.position - b.position);